import React, { useEffect, useRef } from "react";
import "./MultiplySection.css";
import { useNavigate } from "react-router-dom";


const cards = [
  {
    variant: "light",
    icon: "fa-solid fa-chart-line",
    title: "Goal-Based Investment Planning",
    desc: "From child's education to retirement, every goal planned with precision and purpose",
  },
  {
    variant: "dark",
    icon: "fa-solid fa-briefcase",
    title: "Smart Asset Allocation System",
    desc: "A well-structured portfolio built around your risk profile, income, and long-term objectives.",
  },
  {
    variant: "light",
    icon: "fa-solid fa-chart-pie",
    title: " Process-Driven Wealth Building",
    desc: "A repeatable, research-backed investment process designed to grow wealth consistently over time.",
  },

  // {
  //   variant: "dark",
  //   icon: "fas fa-coins",
  //   title: "Commodity Based Smart system",
  //   desc: "Expert guidance on hedging commodity exposure through MCX — tailored for business owners and traders.",
  // },
];

const MultiplySection = () => {
  const revealRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (e) => e.isIntersecting && e.target.classList.add("show"),
        ),
      { threshold: 0.1 },
    );
    if (revealRef.current) obs.observe(revealRef.current);
    return () => obs.disconnect();
  }, []);

  const onTilt = (e, card) => {
    const r = card.getBoundingClientRect();
    const rx = (e.clientY - r.top - r.height / 2) / 20;
    const ry = (r.width / 2 - (e.clientX - r.left)) / 20;
    card.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-12px) translateZ(0)`;
  };

  const onTiltLeave = (e, card) => {
    card.style.transform = "";
  };

  return (
    <section className="wc-ui-multiply-section" id="wc-ui-wealth">
      <div className="wc-ui-multiply-container wc-ui-reveal" ref={revealRef}>
        <h2 className="wc-ui-multiply-title">
          From Financial Chaos to Clarity — <span className="wc-ui-gradient-text">Here's How</span>
        </h2>
        <p className="wc-ui-multiply-subtitle">
          Our data-driven approach combines cutting-edge technology with proven
          financial strategies to maximize your returns while minimizing risk.
        </p>
        <div className="wc-ui-multiply-grid">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`wc-ui-multiply-card wc-ui-multiply-card-${card.variant}`}
              onMouseMove={(e) => onTilt(e, e.currentTarget)}
              onMouseLeave={(e) => onTiltLeave(e, e.currentTarget)}
            >
              <div
                className={`wc-ui-multiply-icon-box wc-ui-multiply-icon-box-${card.variant}`}
              >
                <i className={card.icon}></i>
              </div>
              <h3 className="wc-ui-multiply-card-title">{card.title}</h3>
              <p className="wc-ui-multiply-card-desc">{card.desc}</p>
              <div className="wc-ui-icon-placement">
                <span
                className="wc-ui-multiply-learn-link"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/services")}
              >
                Learn More 
              </span>
                <span  onClick={() => navigate("/contact")} 
                style={{ cursor: "pointer" }}>
                  <i className="fa-solid fa-phone"></i> Contact Us
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MultiplySection;
